export default __webpack_public_path__ + "assets/images/07ac63302eba28420db59d5c91cedb4d.jpg";